import React, { useContext, useState, useEffect } from 'react';
import { ShopContext } from "../context/shopContext";
import userLoggedIn from '../components/assets/user-solid.svg';
import './css/account.css';

const Account = () => {
    const { accountData } = useContext(ShopContext);
    const [activeTab, setActiveTab] = useState('PersonalDetails');
    const [orders, setOrders] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(true);

    // Fetch orders
    useEffect(() => {
        if (accountData?.user?._id) {
            setLoadingOrders(true); // Ensure loading state is set
            fetch(`${process.env.REACT_APP_URL}/api/orders/user/${accountData.user._id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('Bearer')}`,
                },
            })
                .then(res => res.json())
                .then(data => {
                    if (data.orders) {
                        setOrders(data.orders);

                        console.log("this is the data from the api: ", data);

                    } else {
                        console.error('No orders found in response:', data);
                    }
                })
                .catch(err => {
                    console.error('Error fetching orders:', err);
                })
                .finally(() => {
                    setLoadingOrders(false);
                });
        }
    }, [accountData]);

    

    if (!accountData || !accountData.user) {
        return (
            <div>
                <h2>Loading Account...</h2>
            </div>
        );
    }

    const renderTabContent = () => {
        switch (activeTab) {
            case 'PersonalDetails':
                return (
                    <div>
                        <h2>Personal Details</h2>
                        <p>Name: {accountData.user.name || 'User'}</p>
                        <p>Email: {accountData.user.email}</p>
                        <p>Account ID: {accountData.user._id}</p>
                    </div>
                );
            case 'Orders':
                return (
                    <div className='orders-container'>
                        <h2>Your Orders</h2>
                        {loadingOrders ? (
                            <p>Loading orders...</p>
                        ) : orders.length ? (
                            <table className='orders-table'>
                                <thead>
                                <tr>
                                    <th>
                                        Order ID
                                    </th>
                                    <th>
                                        Cost
                                    </th>
                                    <th>
                                        Purchase Date
                                    </th>
                                    <th>
                                        Order Status
                                    </th>
                                </tr>
                                </thead>

                                <tbody>
                                {orders.map(order => (
                                    <tr key={order._id}>
                         
                                        <td>{order._id}</td>
                                        <td>£{order.totalAmount}</td>
                                        <td>{new Date(order.createdAt).toLocaleDateString("en-GB")}</td>
                                        <td>{order.status}</td>

                                    </tr>
                                ))}
                                    </tbody>
                                

                            </table>
                        ) : (
                            <p>No orders found.</p>
                        )}
                    </div>
                );
            // case 'Addresses':
            //     return <h2>Addresses</h2>; // Add address details here
            // case 'Reminders':
            //     return <h2>Reminders</h2>; // Add reminders details here
            // case 'PaymentMethods':
            //     return <h2>Payment Methods</h2>; // Add payment methods details here
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="account-header">
                <img
                    src={userLoggedIn}
                    className="icons"
                    alt=""
                    onClick={() => {
                        localStorage.removeItem("Bearer");
                        window.location.replace("/");
                    }}
                />
                <h1>Welcome, {accountData.user.name || 'User'}</h1>
            </div>
            <div className="tabs">
                <button onClick={() => setActiveTab('PersonalDetails')}>Personal Details</button>
                <button onClick={() => setActiveTab('Orders')}>Orders</button>

                {/* <button onClick={() => setActiveTab('Addresses')}>Addresses</button>
                <button onClick={() => setActiveTab('Reminders')}>Reminders</button>
                <button onClick={() => setActiveTab('PaymentMethods')}>Payment Methods</button> */}
            </div>
            <div className="tab-content">
                {renderTabContent()}
            </div>
        </div>
    );
};

export default Account;
